import { countArticleViews } from '../queries/countArticleViews'

export const totalArticleViewsGauge = {
  queries: [countArticleViews],
  title: 'Total article views',
}
